export const swedishCities = [
  "Alingsås",
  "Arboga",
  "Arvika",
  "Askersund",
  "Avaskär",
  "Avesta",
  "Boden",
  "Bollnäs",
  "Borgholm",
  "Borlänge",
  "Borås",
  "Broo",
  "Brätte",
  "Båstad",
  "Djursholm",
  "Eksjö",
  "Elleholm",
  "Enköping",
  "Eskilstuna",
  "Eslöv",
  "Fagersta",
  "Falkenberg",
  "Falköping",
  "Falsterbo",
  "Falun",
  "Filipstad",
  "Flen",
  "Getakärr",
  "Gränna",
  "Gåsekil",
  "Gällivare",
  "Gävle",
  "Göteborg",
  "Hagfors",
  "Halmstad",
  "Haparanda",
  "Hedemora",
  "Helsingborg",
  "Hjo",
  "Hudiksvall",
  "Huskvarna",
  "Härnösand",
  "Hässleholm",
  "Hästholmen",
  "Höganäs",
  "Järle",
  "Jönköping",
  "Kalmar",
  "Karl Johans stad",
  "Karlshamn",
  "Karlskoga",
  "Karlskrona",
  "Karlstad",
  "Katrineholm",
  "Kiruna",
  "Kongahälla",
  "Korpilombolo",
  "Kramfors",
  "Kristianopel",
  "Kristianstad",
  "Kristinehamn",
  "Kumla",
  "Kungsbacka",
  "Kungälv",
  "Köping",
  "Laholm",
  "Landskrona",
  "Lidingö",
  "Lidköping",
  "Lindesberg",
  "Linköping",
  "Ljungby",
  "Lomma",
  "Ludvika",
  "Luleå",
  "Lund",
  "Luntertun",
  "Lycksele",
  "Lyckå",
  "Lysekil",
  "Lödöse",
  "Malmö",
  "Mariefred",
  "Mariestad",
  "Marstrand",
  "Mjölby",
  "Motala",
  "Mölndal",
  "Mönsterås",
  "Nacka",
  "Nora",
  "Norrköping",
  "Norrtälje",
  "Nya Lidköping",
  "Nya Lödöse",
  "Ny Varberg",
  "Nybro",
  "Nyköping",
  "Nynäshamn",
  "Nässjö",
  "Oskarshamn",
  "Oxelösund",
  "Pajala",
  "Piteå",
  "Ronneby",
  "Sala",
  "Sandviken",
  "Sigtuna",
  "Simrishamn",
  "Skanör",
  "Skanör med Falsterbo",
  "Skara",
  "Skellefteå",
  "Skänninge",
  "Skövde",
  "Sollefteå",
  "Solna",
  "Stockholm",
  "Strängnäs",
  "Strömstad",
  "Stäket",
  "Sundbyberg",
  "Sundsvall",
  "Säffle",
  "Säter",
  "Sävsjö",
  "Söderhamn",
  "Söderköping",
  "Södertälje",
  "Sölvesborg",
  "Tidaholm",
  "Torget",
  "Torshälla",
  "Tranås",
  "Trelleborg",
  "Trollhättan",
  "Trosa",
  "Tumathorp",
  "Tärendö",
  "Uddevalla",
  "Ulricehamn",
  "Umeå",
  "Uppsala",
  "Vadstena",
  "Varberg",
  "Vaxholm",
  "Vetlanda",
  "Vimmerby",
  "Visby",
  "Vä",
  "Vänersborg",
  "Värnamo",
  "Västervik",
  "Västerås",
  "Växjö",
  "Ystad",
  "Åhus",
  "Åmål",
  "Älvsborg",
  "Ängelholm",
  "Örebro",
  "Öregrund",
  "Örnsköldsvik",
  "Östersund",
  "Östhammar"
];
